import { createUseStyles } from 'react-jss';
import { Breakpoints } from '@/lib/breakpoints';
import { BREADCRUMB_HEIGHT, PAGE_GUTTER_X, SITE_GUTTER } from '@/constants/layout';

const useStyles = createUseStyles(
  {
    /**
     * The preset page's breadcrumb row (`PresetCrumbWrap`), reproduced: same
     * height, same distance from the window edge — so the trail doesn't jump
     * when you go from a category to one of its presets.
     *
     * The page around it is padded by `SITE_GUTTER`, while the preset row sits
     * at `PAGE_GUTTER_X`, so the margin cancels the difference.
     */
    root: {
      display: 'flex',
      alignItems: 'center',
      boxSizing: 'border-box',
      height: BREADCRUMB_HEIGHT,
      marginLeft: PAGE_GUTTER_X - SITE_GUTTER.mobile,
      [Breakpoints.SM]: { marginLeft: PAGE_GUTTER_X - SITE_GUTTER.desktop },
    },
  },
  { name: 'breadcrumb-wrap' },
);

export default useStyles;
